import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import { getClients, getJurisdictions, getReports, createReport, updateReport, deleteReport, CreateOrUpdateReport, getUsers } from "./api/entities/entityApi";

export function useClients() {
    return useQuery({ ...queryKeys.clients.all, queryFn: getClients });
}

export function useJurisdictions() {
    return useQuery({ ...queryKeys.jurisdictions.all, queryFn: getJurisdictions });
}

export function useReports() {
    return useQuery({ ...queryKeys.reports.all, queryFn: getReports });
}

export function useUsers() {
    return useQuery({ ...queryKeys.users.all, queryFn: getUsers });
}

export function useCreateReport() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (report: CreateOrUpdateReport) => createReport(report),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.reports.all.queryKey });
        },
    });
}

export function useUpdateReport() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ reportId, report }: { reportId: string; report: CreateOrUpdateReport }) => updateReport(reportId, report),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.reports.all.queryKey });
        },
    });
}

export function useDeleteReport() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (reportId: string) => deleteReport(reportId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.reports.all.queryKey });
        },
    });
}
